import { ItemType } from "core/stores/statements-and-invoices.store";

export type FilterProps = {
    state: any,
    handleChange: any,
    isLoading: boolean
}

export const getItemType = (type: ItemType, lowerCase = true, plural = false) => {
    if (!type) {
        return "";
    }

    let name = type.toString();

    name += plural ? "s" : "";

    return lowerCase ? name.toLowerCase() : name;
}

export const getItemTypes = (type: ItemType, lowerCase = true) => getItemType(type, lowerCase, true);

export const useHandleChange = (handleChange: any, autoUpdate = true) => {
    // const handleSelectChange = (option?: any, name?: string) => handleChange(name, option.value, "", autoUpdate);

    const handleEventChange = (id: string, newValue: any) => handleChange(id, newValue, "", autoUpdate);

    // return { handleSelectChange, handleEventChange };

    return { handleEventChange };
}

export const options = [
    { value: ItemType.statement, label: `${ItemType.statement.toString()}s` },
    { value: ItemType.invoice, label: `${ItemType.invoice.toString()}s` }
]
